import * as actionTypes from "../constants";
import { ImportExportStatuses } from "../models";

import type { ProvidersImportState } from "../models/encounterServiceEntity";

const createImportProvidersState = (): ProvidersImportState => ({
  busy: false,
  facilityId: null,
  taskId: null,
  status: null,
  error: null,
  result: null,
});

export const importProvidersReducer = (state = createImportProvidersState(), action) => {
  switch (action.type) {
    case actionTypes.PROVIDERS_IMPORT_BEGIN_WAIT:
      return {
        ...state,
        busy: true,
      };
    case actionTypes.PROVIDERS_IMPORT_END_WAIT:
      return {
        ...state,
        busy: false,
      };
    case actionTypes.PROVIDERS_IMPORT_SET_STATUS:
      return {
        ...state,
        facilityId: action.payload.facilityId ?? state.facilityId,
        taskId: action.payload.JobId,
        status: action.payload.Status,
        error: action.payload.Error,
        result: action.payload.Result,
        busy: true,
      };
    case actionTypes.PROVIDERS_IMPORT_CANCEL:
      return {
        ...state,
        facilityId: null,
        taskId: null,
        status: null,
        error: null,
        result: null,
        busy: false,
      };
    case actionTypes.PROVIDERS_IMPORT_SET_ERROR:
      return {
        ...state,
        status: ImportExportStatuses.Error,
        error: action.payload,
        busy: false,
      };
    case actionTypes.PROVIDERS_IMPORT_CLEAR_ERROR:
      return {
        ...state,
        error: null,
        status: null,
      };

    default:
      return state;
  }
};
